//#region IMPORTS
import { ProductVersion } from "../../models/productVersion";
import MainTableRowActionDelete from "../_layout/MainTableRowActionDelete";
import MainTableRowActionRead from "../_layout/MainTableRowActionRead";
//#endregion

//#region INTERFACE
interface Props {
  deleteHandler: (productVersion: ProductVersion) => void;
  detailHandler: (productVersion: ProductVersion) => void;
  isAdmin: boolean;
  item: ProductVersion;
}
//#endregion

export default function ProductVersionsTableRow({
  deleteHandler,
  detailHandler,
  isAdmin = false,
  item,
}: Props) {
  //#region RENDER
  return (
    <tr className="border-t border-slate-300 h-10">
      {/* actions */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        <MainTableRowActionRead
          detailHandler={() => detailHandler(item)}
          tooltipId={String(item.number)}
        />
      </td>
      {/* number */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {item.number}
      </td>

      {/* name */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {item.name}
      </td>

      {/* language */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        {item.language}
      </td>

      {/* produced_by */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        {item.produced_by}
      </td>

      {/* Delete */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        <MainTableRowActionDelete
          deleteHandler={() => deleteHandler(item)}
          hide={!isAdmin}
        />
      </td>
    </tr>
  );
  //#endregion
}
